import type { ValuesType } from 'utility-types'

export const PrefetchStrategy = {
  PREFETCH: 'prefetch',
  PRERENDER: 'prerender',
  NEVER: 'never',
  AUTO: undefined,
} as const

export type PrefetchStrategy = ValuesType<typeof PrefetchStrategy>
